// istanbul ignore file
type PropertyKeyInformation = {
    onsiteAvailability: PropertyKeyAvailableType;
    validFrom: Date | null;
    temporaryKeyExpirationDate: Date | null;
    keyOnsiteNotes: string;
};

enum PropertyKeyAvailableType {
    Available = 'AVAILABLE',
    Unavailable = 'UNAVAILABLE',
    Temporary = 'TEMPORARY'
}

function getReadableOnsiteAvailability(onsiteAvailability: PropertyKeyAvailableType): string {
    switch (onsiteAvailability) {
        case PropertyKeyAvailableType.Available:
            return 'Available';
        case PropertyKeyAvailableType.Temporary:
            return 'Temporary';
        case PropertyKeyAvailableType.Unavailable:
            return 'Unavailable';
        default:
            return 'Unknown';
    }
}

export {
    PropertyKeyInformation,
    PropertyKeyAvailableType,
    getReadableOnsiteAvailability,
};
